module.exports = __webpack_public_path__ + "static/img/13.075fb0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/13.jpg
// module id = Fm6L
// module chunks = 1